/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  SubscriptionAdditionalPaymentData,
  UpdateSubscriptionInput,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    SubscriptionAdditionalPaymentDataFromJSON,
    SubscriptionAdditionalPaymentDataToJSON,
    UpdateSubscriptionInputFromJSON,
    UpdateSubscriptionInputToJSON,
} from '../models/index';

export interface ChangeSubscriptionRequest {
    projectId: string;
    packageId: string;
    updateSubscriptionInput?: UpdateSubscriptionInput;
}

export interface CheckSubscriptionPaymentSetupRequest {
    projectId: string;
}

export interface GetSubscriptionChangePriceRequest {
    projectId: string;
    packageId: string;
}

/**
 * 
 */
export class SubscriptionApi extends runtime.BaseAPI {

    /**
     * Create or change a subscription for a project.
     */
    async changeSubscriptionRaw(requestParameters: ChangeSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling changeSubscription().'
            );
        }

        if (requestParameters['packageId'] == null) {
            throw new runtime.RequiredError(
                'packageId',
                'Required parameter "packageId" was null or undefined when calling changeSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/project/{projectId}/subscribe/{packageId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"packageId"}}`, encodeURIComponent(String(requestParameters['packageId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSubscriptionInputToJSON(requestParameters['updateSubscriptionInput']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Create or change a subscription for a project.
     */
    async changeSubscription(requestParameters: ChangeSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.changeSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check subscription payment setup.
     */
    async checkSubscriptionPaymentSetupRaw(requestParameters: CheckSubscriptionPaymentSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ErrorResponse>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling checkSubscriptionPaymentSetup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/project/{projectId}/subscription/check-payment-setup`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseFromJSON(jsonValue));
    }

    /**
     * Check subscription payment setup.
     */
    async checkSubscriptionPaymentSetup(requestParameters: CheckSubscriptionPaymentSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ErrorResponse> {
        const response = await this.checkSubscriptionPaymentSetupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find out if an additional payment is needed to change the subscription
     */
    async getSubscriptionChangePriceRaw(requestParameters: GetSubscriptionChangePriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionAdditionalPaymentData>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getSubscriptionChangePrice().'
            );
        }

        if (requestParameters['packageId'] == null) {
            throw new runtime.RequiredError(
                'packageId',
                'Required parameter "packageId" was null or undefined when calling getSubscriptionChangePrice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/project/{projectId}/subscribe/{packageId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"packageId"}}`, encodeURIComponent(String(requestParameters['packageId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionAdditionalPaymentDataFromJSON(jsonValue));
    }

    /**
     * Find out if an additional payment is needed to change the subscription
     */
    async getSubscriptionChangePrice(requestParameters: GetSubscriptionChangePriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionAdditionalPaymentData> {
        const response = await this.getSubscriptionChangePriceRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
